import { render, staticRenderFns } from "./TaskStepViewer.vue?vue&type=template&id=168a4f06&scoped=true"
import script from "./TaskStepViewer.vue?vue&type=script&lang=js"
export * from "./TaskStepViewer.vue?vue&type=script&lang=js"
import style0 from "./TaskStepViewer.vue?vue&type=style&index=0&id=168a4f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a4f06",
  null
  
)

export default component.exports